import { IonIcon, IonLabel, IonChip } from '@ionic/react'
import { useStore } from 'effector-react'
import { bulb } from 'ionicons/icons'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { signingCancel, signingCancelFx } from './model'
import { Title } from './styled'

type CancelBookingDrawerProps = {
  isShow: boolean
  onCancel: () => void
}

export function CancelBookingDrawer({
  isShow,
  onCancel,
}: CancelBookingDrawerProps) {
  const singingCancelPending = useStore(signingCancelFx.pending)

  const handleSigningCancel = () => {
    signingCancel({ onDrawerClose: onCancel })
  }

  return (
    <DrawerComponent isShow={isShow} onCancel={onCancel}>
      <Title>Вы уверенны, что хотите отменить бронь ?</Title>

      <IonChip color='warning' style={{ marginBottom: '16px' }}>
        <IonIcon icon={bulb}></IonIcon>
        <IonLabel>
          Бронь отменится в течение нескольких минут после подтверждения!
        </IonLabel>
      </IonChip>

      <Button
        variant='coralFlooded'
        size='large'
        fullWidth
        loading={singingCancelPending}
        onClick={handleSigningCancel}
      >
        Подтвердить отмену
      </Button>
    </DrawerComponent>
  )
}
